import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Linkedin, Facebook, Instagram, Twitter, ArrowRight, Shield, Award, Clock } from "lucide-react";
import { Button } from "@/components/ui/button-variants";
import { Input } from "@/components/ui/input";
import logoLight from "@/assets/logo-mind-medical-light.png";

const Footer = () => {
  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle newsletter subscription
  };

  return (
    <footer className="bg-gradient-to-br from-primary via-primary/95 to-secondary text-white">
      {/* Newsletter Section - Désactivée temporairement
      <div className="border-b border-white/10">
        <div className="container mx-auto px-4 py-12 md:py-16">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="font-poppins font-bold text-2xl md:text-3xl mb-4">
              Restez informé des nouvelles opportunités
            </h3>
            <p className="text-white/80 mb-8 text-lg">
              Recevez nos meilleures offres d'emploi et conseils carrière directement par email
            </p>
            <form onSubmit={handleNewsletterSubmit} className="flex flex-col sm:flex-row gap-3 max-w-xl mx-auto">
              <Input
                type="email"
                placeholder="Votre adresse email"
                className="flex-1 bg-white/10 border-white/20 text-white placeholder:text-white/60 focus:bg-white/15"
                required
              />
              <Button variant="default" size="lg" className="bg-white text-primary hover:bg-white/95 font-semibold">
                S'abonner
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </form>
          </div>
        </div>
      </div>
      */}

      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="lg:col-span-2 space-y-6">
            <div className="flex items-center">
              <img 
                src={logoLight} 
                alt="Mind Medical - Agence d'Intérim Médical" 
                className="h-20 w-auto"
                width="1657"
                height="457"
              />
            </div>
            <p className="text-white/80 text-base leading-relaxed">
              Agence indépendante d'intérim médical. Un accompagnement 100% humain, réactif et personnalisé pour les professionnels de santé.
            </p>
            
            {/* Trust Badges */}
            <div className="flex flex-wrap gap-4 pt-2">
              <div className="flex items-center gap-2 px-3 py-2 bg-white/10 rounded-lg backdrop-blur-sm">
                <Shield className="w-4 h-4 text-white" />
                <span className="text-sm font-medium text-white">De confiance</span>
              </div>
              <div className="flex items-center gap-2 px-3 py-2 bg-white/10 rounded-lg backdrop-blur-sm">
                <Award className="w-4 h-4 text-white" />
                <span className="text-sm font-medium text-white">Excellence</span>
              </div>
              <div className="flex items-center gap-2 px-3 py-2 bg-white/10 rounded-lg backdrop-blur-sm">
                <Clock className="w-4 h-4 text-white" />
                <span className="text-sm font-medium text-white">Dispo 7j/7</span>
              </div>
            </div>
          </div>

          {/* Quick Links - Candidats */}
          <div>
            <h3 className="font-poppins font-bold text-white text-lg mb-6">Pour les candidats</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/offres" className="text-white/80 hover:text-white transition-colors text-sm flex items-center group">
                  <ArrowRight className="w-3 h-3 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Offres d'emploi
                </Link>
              </li>
              <li>
                <Link to="/metiers" className="text-white/80 hover:text-white transition-colors text-sm flex items-center group">
                  <ArrowRight className="w-3 h-3 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Métiers
                </Link>
              </li>
              <li>
                <Link to="/inscription-medecin" className="text-white/80 hover:text-white transition-colors text-sm flex items-center group">
                  <ArrowRight className="w-3 h-3 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Inscription médecin
                </Link>
              </li>
              <li>
                <Link to="/espace-medecin" className="text-white/80 hover:text-white transition-colors text-sm flex items-center group">
                  <ArrowRight className="w-3 h-3 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Espace Médecin
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-white/80 hover:text-white transition-colors text-sm flex items-center group">
                  <ArrowRight className="w-3 h-3 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Blog & Conseils
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links - Entreprise */}
          <div>
            <h3 className="font-poppins font-bold text-white text-lg mb-6">L'entreprise</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-white/80 hover:text-white transition-colors text-sm flex items-center group">
                  <ArrowRight className="w-3 h-3 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  À propos
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-white/80 hover:text-white transition-colors text-sm flex items-center group">
                  <ArrowRight className="w-3 h-3 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/80 hover:text-white transition-colors text-sm flex items-center group">
                  <ArrowRight className="w-3 h-3 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Contact
                </Link>
              </li>
              <li>
                <a href="https://www.linkedin.com/company/109562095" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white transition-colors text-sm flex items-center group">
                  <ArrowRight className="w-3 h-3 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Carrières
                </a>
              </li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h3 className="font-poppins font-bold text-white text-lg mb-6">Contact</h3>
            <ul className="space-y-4 mb-6">
              <li>
                <a href="tel:+33189715625" className="flex items-center text-white/80 hover:text-white transition-colors text-sm group">
                  <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center mr-3 group-hover:bg-white/20 transition-colors">
                    <Phone className="w-4 h-4" />
                  </div>
                  <span>01 89 71 56 25</span>
                </a>
              </li>
              <li>
                <a href="mailto:contact@mind-medical.com" className="flex items-center text-white/80 hover:text-white transition-colors text-sm group">
                  <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center mr-3 group-hover:bg-white/20 transition-colors">
                    <Mail className="w-4 h-4" />
                  </div>
                  <span className="break-all">contact@mind-medical.com</span>
                </a>
              </li>
              <li className="flex items-start text-white/80 text-sm">
                <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center mr-3 flex-shrink-0">
                  <MapPin className="w-4 h-4" />
                </div>
                <span>
                  52 boulevard de l'Yerres<br />
                  91000 Evry-Courcouronnes
                </span>
              </li>
            </ul>

            <div className="pt-4 border-t border-white/10">
              <p className="text-sm font-semibold text-white mb-3">Suivez-nous</p>
              <div className="flex gap-2">
                <a href="https://www.linkedin.com/company/109562095" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-white rounded-lg flex items-center justify-center transition-all group" aria-label="LinkedIn">
                  <Linkedin className="w-5 h-5 text-white group-hover:text-primary" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white/70 text-center md:text-left">
              © 2026 Mind Medical. Tous droits réservés. Created with ♥️ by{' '}
              <a 
                href="https://www.mycompartner.fr/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-white/70 hover:text-white transition-colors font-medium"
              >
                myCOM Partner
              </a>
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              <Link to="/mentions-legales" className="text-white/70 hover:text-white transition-colors">
                Mentions légales
              </Link>
              <span className="text-white/30">•</span>
              <Link to="/confidentialite" className="text-white/70 hover:text-white transition-colors">
                Politique de confidentialité
              </Link>
              <span className="text-white/30">•</span>
              <Link to="/plan-du-site" className="text-white/70 hover:text-white transition-colors">
                Plan du site
              </Link>
              <span className="text-white/30">•</span>
              <button
                type="button"
                onClick={() => window.dispatchEvent(new CustomEvent("open-cookie-banner"))}
                className="text-white/70 hover:text-white transition-colors"
              >
                Cookies
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;